import { axiosPrivate } from 'app/utils';

import helpers from './helpers';

export default {
  async getAll(params) {
    const { page = 0, limit = 5 } = params;

    const response = await axiosPrivate.get(`/announcements?page=${page}&limit=${limit}`);
    if (response.data.error) helpers.throwError(response.data.error);

    return response.data;
  },
};
